import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { TabEnum } from 'Common/Constants/Enumeration/TruckRouteEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';

import * as Selectors from './state/settings/selectors';
import { setSelectedTab } from './state/settings/actions';
import { ManageTruckRoutesComponent } from './containers/managetruckrouteslist/ManageTruckRoutesList';
import { Truckrouteschedule } from './containers/managetruckrouteschedulelist/ManageTruckRouteScheduleList';
import { BASE_URL } from './helper/index';

class TruckRouteContainer extends Component {
  static propTypes = {
    allTableStates: PropTypes.object,
    setTableStates: PropTypes.func.isRequired,
    selectedTab: PropTypes.string.isRequired,
  };
  static defaultProps = {
    allTableStates: null,
  };

  headerRowButtons = [
    {
      title: 'Setup',
      value: TabEnum.TruckRoute,
      preferValue: PrefEnum.TruckRouteSetup,
    },
    {
      title: 'Schedule',
      value: TabEnum.TruckRouteSchedule,
      preferValue: PrefEnum.TruckRouteSchedule,
    },
  ];

  componentWillUnmount() {
    this.clearTableSavedState();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.MANAGE_TRUCK_ROUTE_TABLE,
      TableNamesEnum.MANAGE_TRUCK_ROUTE_SCHEDULE_TABLE,
    ]);
  };

  onCreateRouteClick = () => {
    this.props.history.push(`${BASE_URL}/route/0/0`);
  };

  onCreateRouteScheduleClick = () => {
    this.props.history.push(`${BASE_URL}/schedule/0/0`);
  };

  render() {
    const { selectedTab } = this.props;
    return (
      <Fragment>
        <Filter title={'Truck Routes'} newRow={true}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12}>
                <Button.Group basic className="btn-group--active-group">
                  {this.headerRowButtons.map(button => {
                    const { title, value, preferValue } = button;
                    return (
                      <SecurityPreferences
                        scope={preferValue}
                        key={`security${value}`}
                      >
                        {disabled => {
                          return (
                            !disabled && (
                              <Button
                                key={button.title}
                                basic
                                className="white"
                                active={selectedTab === button.value}
                                onClick={() =>
                                  this.props.setSelectedTab(button.value)
                                }
                              >
                                {title}
                              </Button>
                            )
                          );
                        }}
                      </SecurityPreferences>
                    );
                  })}
                </Button.Group>
              </Grid.Column>
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <SecurityPreferences scope={PrefEnum.TruckRouteSetup}>
                  {disabled => {
                    return (
                      !disabled &&
                      selectedTab === TabEnum.TruckRoute && (
                        <Button
                          content="Create New"
                          type={'button'}
                          onClick={this.onCreateRouteClick}
                        />
                      )
                    );
                  }}
                </SecurityPreferences>
                <SecurityPreferences scope={PrefEnum.TruckRouteSchedule}>
                  {disabled => {
                    return (
                      !disabled &&
                      selectedTab === TabEnum.TruckRouteSchedule && (
                        <Button
                          content="Create New"
                          type={'button'}
                          onClick={this.onCreateRouteScheduleClick}
                        />
                      )
                    );
                  }}
                </SecurityPreferences>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <SecurityPreferences scope={PrefEnum.TruckRouteSetup}>
            {disabled => {
              return (
                !disabled &&
                selectedTab === TabEnum.TruckRoute && (
                  <ManageTruckRoutesComponent {...this.props} />
                )
              );
            }}
          </SecurityPreferences>
          <SecurityPreferences scope={PrefEnum.TruckRouteSchedule}>
            {disabled => {
              return (
                !disabled &&
                selectedTab === TabEnum.TruckRouteSchedule && (
                  <Truckrouteschedule {...this.props} />
                )
              );
            }}
          </SecurityPreferences>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty()(state));
  return {
    selectedTab: Selectors.getSelectedTab(state),
    allTableStates: getTableStates(state),
  };
};
const mapDispatchToProps = {
  setSelectedTab,
  setTableStates,
};

export const TruckRoutes = connect(
  mapStateToProps,
  mapDispatchToProps
)(TruckRouteContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/TruckRouteContainer.js